import { format } from "date-fns";
import Joi from "joi";
import { Dropdown, Spinner } from "react-bootstrap";
import { Controller, useFormContext } from "react-hook-form";
import Form from "react-bootstrap/Form";
import select from "@/assets/img/selectOption.svg";
import { useContext, useEffect, useState } from "react";
import {
  FilterSearch,
  FilterSearchToggle,
} from "@/components/filter-search/filter-search";
import { BudgetContext } from "@/page-components/budgets/budget.context";
import { ReportingContext } from "../reporting-context-file";

export const CreateAllCloudReport = (context) =>
  Joi.object({
    NAME: Joi.string().required().messages({
      "string.empty": "Report name is required",
      "any.required": "Report name is required",
    }),
    group_by: Joi.string().required().messages({
      "any.required": "Group By is required",
      "string.empty": "Group By is required",
      // "string.base": "Group by must be a string",
    }),

    Tags: Joi.string(),
    Dimension: Joi.string(),

    PERIOD: Joi.string()
      // .valid(
      //   "LAST_WEEK",
      //   "THIS_WEEK",
      //   "THIS_MONTH",
      //   "LAST_MONTH",
      //   "THIS_QUARTER",
      //   "CUSTOM"
      // )
      .required()
      .messages({
        "string.empty": "Period is required",
        "any.required": "Period is required",
      }),

    Frequency: Joi.string()
      // .valid("ONE_TIME", "WEEKLY", "MONTHLY")
      .required()
      .messages({
        "string.empty": "Frequency is required",
        "any.required": "Frequency is required",
      }),

    ALERTS_RECEIPIENTS: Joi.array()
      .items(
        Joi.string()
          .email({ tlds: { allow: false } })
          .messages({
            "string.email": "Each recipient must be a valid email",
          })
      )
      .min(1)
      .required()
      .messages({
        "array.min": "Alert recipients is required",
        "array.base": "Alert recipients is required",
        "array.empty": "Alert recipients is required",
        "any.required": "Alert recipients are required",
      }),
  });

// ---------------------------------------------------------------------------------------------

export const SelectField = (props) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const filterTags = (tags) => {
    if (!searchQuery) return tags;
    return tags.filter((tag) =>
      (tag.name || tag.id || "")
        .toLowerCase()
        .includes(searchQuery.toLowerCase())
    );
  };

  const filteredTags = filterTags(props.commonFieldData || []);
  const { rules } = props || {};
  const { onSelect = () => {} } = props;

  return (
    <div className="accountid_box">
      <div className="accountid_name" style={{ cursor: "not-allowed" }}>
        {props.title} {props.unit ? props.unit : " "}
        <span className="astriek_css">
          {props.title !== "Dimension" && props.title !== "Tags" && <b>*</b>}
        </span>
      </div>

      <div style={{ display: "flex", position: "relative" }}>
        <Controller
          control={props.control || ""}
          name={props.fieldName || ""}
          rules={rules}
          render={({ field: { value, onChange } }) => (
            <>
              <Dropdown
                className="input_box_css"
                style={{ width: props?.CustomWidth === true ? "270px" : "" }}
                onSelect={(selected) => {
                  onChange(selected);
                  onSelect(selected);
                }}
                onToggle={(isOpen) => {
                  setIsDropdownOpen(isOpen);
                  if (isOpen) setSearchQuery("");
                }}
              >
                <Dropdown.Toggle
                  variant="light"
                  id="dropdown-basic"
                  className="dropdown_Toggel"
                  disabled={props?.disableOption || props?.disableValue}
                >
                  <span style={!value ? { color: "#ADB5BD" } : {}}>
                    {value
                      ? (props.commonFieldData || []).find(
                          (e) => e.id === value
                        )?.name
                      : props?.placeholder}
                  </span>
                </Dropdown.Toggle>

                <Dropdown.Menu className="alligment" id="insetStyles">
                  {props.search && (
                    <Form.Control
                      autoFocus
                      type="search"
                      className="w-100 mb-2"
                      placeholder="Search..."
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                    />
                  )}

                  {props?.isLoading ? (
                    <div style={{ textAlign: "center" }}>
                      <Spinner />
                    </div>
                  ) : (
                    <div
                      style={{
                        overflowY: filteredTags.length > 15 ? "scroll" : "",
                        maxHeight: "450px",
                      }}
                    >
                      {filteredTags.map((e) => (
                        <Dropdown.Item key={e.id} eventKey={e.id}>
                          {e?.name || e?.id || "--"}
                        </Dropdown.Item>
                      ))}

                      {filteredTags.length === 0 && (
                        <div style={{ textAlign: "center", padding: "10px" }}>
                          No {props?.title} found.
                        </div>
                      )}
                    </div>
                  )}
                </Dropdown.Menu>
              </Dropdown>
            </>
          )}
        />
        <img
          style={{ position: "absolute", right: "10px", top: "13px" }}
          src={select}
          width={"10px"}
          height={"10px"}
          alt="icon"
        />
      </div>

      <div
        style={{
          height: "10px",
          display: "flex",
          marginBottom: props?.title === "Frequency" ? "16px" : "0px",
        }}
      >
        {rules?.message && (
          <span className="budgetsError">{rules.message}</span>
        )}
      </div>
    </div>
  );
};
